module.exports = __webpack_public_path__ + "img/ufa-service-hub-wide-v5.c0162d94.webp";